export enum SalutationTypeOptions {
	Divers = "Divers",
	Mr = "Mr",
	Mrs = "Mrs",
}
